import { ACTIONS } from './SquareIntegrationSettings.constants';

export function getOptions() {
  return ACTIONS.map((action) => ({
    key: action,
    text: action,
    value: action,
  }));
}
